import React from 'react';
import { useSelector } from 'react-redux';
import { selectStatusById } from '@store/selectors/solicitacaoSelector';
import { useAppAuth } from '@contexts/AuthContext';

const RenderIfStatusAndRole = ({
  idSolicitacao,
  allowedStatuses = [],
  allowedRoles = [],
  flagAuditoria,
  onlyIfAuditoria,     // booleano opcional
  children
}) => {
  const status = useSelector(selectStatusById(idSolicitacao));
  const { role } = useAppAuth();

  const isStatusAllowed = allowedStatuses.includes(status);
  const isRoleAllowed = allowedRoles.includes(role);

  const isAuditoriaServico = flagAuditoria === true;

  // só restringe se onlyIfAuditoria for definido
  const isTipoServicoAllowed =
    onlyIfAuditoria === undefined || onlyIfAuditoria === isAuditoriaServico;

  const canRender = isStatusAllowed && isRoleAllowed && isTipoServicoAllowed;

  if (!canRender) return null;

  return <div>{children}</div>;
};

export default RenderIfStatusAndRole;
